
export const detectChangesLog = (isEditing, baseClientsRef, baseUsersRef, clients, users) => {
  const logs = []
  if (!isEditing) return logs

  const previousClients = baseClientsRef.current || []
  const previousClientsMap = new Map(previousClients.map(c => [c.value, c]))

  clients.forEach((current) => {
    const oldClient = previousClientsMap.get(current.value)

    // Cliente nuevo
    if (!oldClient) {
      logs.push({
        entity_type: 'client',
        entity_uid: current.value,
        action_type: 'add',
        data: {
          visitDays: current.visitDays,
          recurrenceType: current.recurrenceType,
          recurrenceAmount: current.recurrenceAmount,
          recurrence: current.recurrence
        }
      })
      return
    }

    const changed =
      JSON.stringify([...(oldClient.visitDays || [])].sort()) !==
      JSON.stringify([...(current.visitDays || [])].sort()) ||
      oldClient.startDate !== current.startDate ||
      oldClient.recurrence !== current.recurrence ||
      oldClient.recurrenceType !== current.recurrenceType ||
      oldClient.recurrenceAmount !== current.recurrenceAmount

    if (changed) {
      logs.push({
        entity_type: 'client',
        entity_uid: current.value,
        action_type: 'update',
        source: 'admin-ui',
        data: {
          visitDays: current.visitDays,
          recurrenceType: current.recurrenceType,
          recurrenceAmount: current.recurrenceAmount,
          recurrence: current.recurrence
        }
      })
    }

    previousClientsMap.delete(current.value)
  })

  // Clientes eliminados
  previousClientsMap.forEach((oldClient) => {
    logs.push({
      entity_type: 'client',
      entity_uid: oldClient.value,
      action_type: 'delete',
      data: {}
    })
  })

  const prevUserSet = new Set((baseUsersRef.current || []).map(u => u.uid))
  const currentUserSet = new Set(users.map(u => u.uid))

  // Nuevos usuarios
  currentUserSet.forEach((uid) => {
    if (!prevUserSet.has(uid)) {
      logs.push({
        entity_type: 'user',
        entity_uid: uid,
        action_type: 'add',
        data: {}
      })
    }
  })

  // Usuarios eliminados
  prevUserSet.forEach((oldUid) => {
    if (!currentUserSet.has(oldUid)) {
      logs.push({
        entity_type: 'user',
        entity_uid: oldUid,
        action_type: 'delete',
        data: {}
      })
    }
  })

  return logs
}
